import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useSendPostBack(): (value?: any) => void {
  return useWebChatAPIContext().sendPostBack;
}
